import { api } from "@infrastructure/api";
const GLOBAL_CONTEXT = { orgContext: "global" };
const TENANT_CONTEXT = { orgContext: "tenant" };
function idempotencyConfig(idempotencyKey) {
    return {
        ...GLOBAL_CONTEXT,
        headers: {
            "Idempotency-Key": idempotencyKey,
        },
    };
}
export const paymentOperationsRepository = {
    async getPlatformDashboard() {
        const response = await api.get("/admin/global/payments/dashboard", GLOBAL_CONTEXT);
        return response.data;
    },
    async listPlatformRequests(params = {}) {
        const response = await api.get("/admin/global/payments/requests", {
            ...GLOBAL_CONTEXT,
            params,
        });
        return response.data;
    },
    async listPlatformReconciliation(params = {}) {
        const response = await api.get("/admin/global/payments/reconciliation", {
            ...GLOBAL_CONTEXT,
            params,
        });
        return response.data;
    },
    async listPlatformRefunds(params = {}) {
        const response = await api.get("/admin/global/payments/refunds", {
            ...GLOBAL_CONTEXT,
            params,
        });
        return response.data;
    },
    async listPlatformPayables(params = {}) {
        const response = await api.get("/admin/global/payments/payables", {
            ...GLOBAL_CONTEXT,
            params,
        });
        return response.data;
    },
    async listPlatformPayoutBatches(params = {}) {
        const response = await api.get("/admin/global/payments/payout-batches", {
            ...GLOBAL_CONTEXT,
            params,
        });
        return response.data;
    },
    async listPlatformOnvoEvents(params = {}) {
        const response = await api.get("/admin/global/payments/onvo-events", {
            ...GLOBAL_CONTEXT,
            params,
        });
        return response.data;
    },
    async listTenantCollections(params = {}) {
        const response = await api.get("/payments/collections", {
            ...TENANT_CONTEXT,
            params,
        });
        return response.data;
    },
    async listTenantProviderPayables(params = {}) {
        const response = await api.get("/payments/provider-payables", {
            ...TENANT_CONTEXT,
            params,
        });
        return response.data;
    },
    async requestRefund(paymentRequestId, payload, idempotencyKey) {
        const response = await api.post(`/admin/global/payments/requests/${paymentRequestId}/refunds`, payload, idempotencyConfig(idempotencyKey));
        return response.data;
    },
    async createPayoutBatch(payload, idempotencyKey) {
        const response = await api.post("/admin/global/payments/payout-batches", payload, idempotencyConfig(idempotencyKey));
        return response.data;
    },
    async updatePayoutBatch(payoutBatchId, payload) {
        const response = await api.patch(`/admin/global/payments/payout-batches/${payoutBatchId}`, payload, GLOBAL_CONTEXT);
        return response.data;
    },
    async resolveReconciliation(reconciliationId, payload) {
        const response = await api.patch(`/admin/global/payments/reconciliation/${reconciliationId}`, payload, GLOBAL_CONTEXT);
        return response.data;
    },
};
export default paymentOperationsRepository;
